import api from './api';

const authService = {
  // Login: POST auth/jwt/create (body: email, password)
  login: async (email, password, otp_code) => {
    const response = await api.post(
      'auth/jwt/create',
      { email, password, ...(otp_code ? { otp_code } : {}) },
      { skipAuthRefresh: true } // <-- important: don't try refresh if login fails
    );

    const { access, refresh } = response.data || {};
    if (access) localStorage.setItem('accessToken', access);
    if (refresh) localStorage.setItem('refreshToken', refresh);

    return response.data;
  },

  // Refresh: POST auth/jwt/refresh (body: refresh token)
  refresh: async (refreshToken) => {
    const token = refreshToken || localStorage.getItem('refreshToken');
    if (!token) {
      throw new Error('No refresh token available');
    }

    const response = await api.post(
      'auth/jwt/refresh/',
      { refresh: token },
      { skipAuthRefresh: true }
    );

    const { access, refresh } = response.data || {};
    if (access) localStorage.setItem('accessToken', access);
    if (refresh) localStorage.setItem('refreshToken', refresh);

    return response.data;
  },

  // Verify: POST auth/jwt/verify (body: access token)
  // Returns true if token is valid/active, false otherwise.
  verify: async (accessToken) => {
    const token = accessToken || localStorage.getItem('accessToken');
    if (!token) return false;

    try {
      await api.post('auth/jwt/verify', { token });
      return true;
    } catch (e) {
      return false;
    }
  },

  // User creation: POST auth/users/
  register: async ({ email, username, password, re_password, ...rest }) => {
    const payload = { email, username, password, re_password, ...rest };
    const response = await api.post('auth/users/', payload);
    return response.data;
  },

  // Activation: POST auth/users/activation/
  activate: async ({ uid, token }) => {
    await api.post('auth/users/activation/', { uid, token });
    return true;
  },

  // Password reset request: POST auth/users/reset_password/
  requestPasswordReset: async (email) => {
    await api.post('auth/users/reset_password/', { email });
    return true;
  },

  // Password reset confirm/update: POST auth/users/reset_password_confirm/
  confirmPasswordReset: async ({ uid, token, new_password, re_new_password }) => {
    await api.post('auth/users/reset_password_confirm/', {
      uid,
      token,
      new_password,
      re_new_password,
    });
    return true;
  },

  // Current user: GET auth/users/me/
  me: async () => {
    // This call is used during app bootstrap. If the token is stale,
    // AuthProvider should clear local auth state silently instead of
    // forcing a global redirect away from public pages like the landing page.
    const response = await api.get('auth/users/me/', { skipAuthRefresh: true });
    return response.data;
  },

  // Logout
  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  },

  // Quick check (presence only). Use verify() to confirm token is still valid.
  isAuthenticated: () => {
    return !!localStorage.getItem('accessToken');
  },
};

export default authService;
